// extracted by mini-css-extract-plugin
module.exports = {"main-content":"LoadingAnimation_main-content__O_m9B","loadingAnimation":"LoadingAnimation_loadingAnimation__3WE9W","fixed":"LoadingAnimation_fixed__3PWRE"};